/* eslint-disable */
import React,{useState,useEffect,useCallback} from "react";
var T={accent:"#C48A0E",green:"#1E8A55",red:"#C0392B",blue:"#1A5FB4",purple:"#6527BE",teal:"#0E7490",orange:"#C05800",muted:"#7A90B0",text:"#1A2235",border:"#E2E8F3",card:"#fff",faint:"#F7F9FD",font:"DM Sans,system-ui",mono:"IBM Plex Mono,monospace"};
var sc=function(s){return({healthy:T.green,online:T.green,Online:T.green,Active:T.green,running:T.green,idle:T.blue,offline:T.red,Offline:T.red,restarting:T.orange,error:T.red,critical:T.red,pending:T.accent,unknown:T.muted})[s]||T.muted;};
function SC(p){return <div style={{background:T.card,borderRadius:12,padding:"16px 18px",border:"1px solid "+T.border}}><div style={{fontSize:11,color:T.muted,fontWeight:600,textTransform:"uppercase"}}>{p.l}</div><div style={{fontSize:28,fontWeight:800,color:p.c||T.accent,fontFamily:T.mono,marginTop:4}}>{p.v}</div><div style={{fontSize:11,color:T.muted,marginTop:2}}>{p.s}</div></div>;}
function Bd({t,c}){return <span style={{padding:"2px 8px",borderRadius:10,fontSize:9,fontWeight:700,background:(c||T.muted)+"15",color:c||T.muted}}>{t}</span>;}
function Btn({onClick,bg,children,sm,disabled}){return <button onClick={onClick} disabled={disabled} style={{padding:sm?"5px 10px":"8px 16px",borderRadius:8,border:"none",background:disabled?T.muted:bg||T.accent,color:"#fff",fontSize:sm?10:12,fontWeight:700,cursor:disabled?"not-allowed":"pointer",fontFamily:T.font,opacity:disabled?0.5:1}}>{children}</button>;}
function Crd({title,children,accent}){return <div style={{background:T.card,borderRadius:12,border:"1px solid "+(accent?T.accent+"33":T.border),padding:18,marginBottom:16}}>{title&&<div style={{fontSize:14,fontWeight:700,marginBottom:14}}>{title}</div>}{children}</div>;}
function TH({children}){return <th style={{textAlign:"left",padding:"10px 12px",borderBottom:"2px solid "+T.border,color:T.muted,fontSize:11,fontWeight:600,textTransform:"uppercase"}}>{children}</th>;}
function TD({children,mono,bold}){return <td style={{padding:"10px 12px",color:T.text,fontFamily:mono?T.mono:T.font,fontSize:mono?11:12,fontWeight:bold?700:400}}>{children}</td>;}
function Empty({t,s}){return <div style={{textAlign:"center",padding:"40px 20px",color:T.muted}}><div style={{fontWeight:700,color:T.text,marginBottom:4}}>{t}</div><div style={{fontSize:12}}>{s}</div></div>;}

var API="";

// ============================================================
// MQTT Agent Control Dashboard
// ============================================================
export function MqttAgentControlPage(props){
  var [agents,setAgents]=useState({});
  var [loading,setLoading]=useState(true);
  var [cmdLog,setCmdLog]=useState([]);
  var [sending,setSending]=useState("");
  var [cmdModal,setCmdModal]=useState(null);
  var [cmdForm,setCmdForm]=useState({cameraId:"",rtspUrl:"",model:"person_detection"});

  var token=props.token||localStorage.getItem("auravex_token");
  var headers={"Content-Type":"application/json",Authorization:"Bearer "+token};

  var fetchAgents=useCallback(function(){
    fetch(API+"/api/agents/status",{headers:headers})
    .then(function(r){return r.json();})
    .then(function(d){if(d.success)setAgents(d.agents||{});setLoading(false);})
    .catch(function(){setLoading(false);});
  },[token]);

  useEffect(function(){
    fetchAgents();
    var iv=setInterval(fetchAgents,5000);
    return function(){clearInterval(iv);};
  },[fetchAgents]);

  function sendCmd(agentId,cmd,params){
    setSending(agentId+":"+cmd);
    var agent=agents[agentId]||{};
    fetch(API+"/api/agents/"+agentId+"/command",{
      method:"POST",headers:headers,
      body:JSON.stringify({tenantId:agent.tenantId||"T6514",siteId:agent.siteId||"ST-002",cmd:cmd,params:params||{}})
    })
    .then(function(r){return r.json();})
    .then(function(d){
      setCmdLog(function(prev){return [{ts:new Date().toLocaleTimeString(),agent:agentId,cmd:cmd,result:d.success?"OK":"FAIL",msg:d.message||d.error||""}].concat(prev).slice(0,50);});
      setSending("");
      if(cmd==="ping")setTimeout(fetchAgents,2000);
    })
    .catch(function(e){
      setCmdLog(function(prev){return [{ts:new Date().toLocaleTimeString(),agent:agentId,cmd:cmd,result:"ERR",msg:e.message}].concat(prev).slice(0,50);});
      setSending("");
    });
  }

  function sendStartInference(agentId){
    var agent=agents[agentId]||{};
    fetch(API+"/api/agents/"+agentId+"/start",{
      method:"POST",headers:headers,
      body:JSON.stringify({tenantId:agent.tenantId||"T6514",siteId:agent.siteId||"ST-002",cameraId:cmdForm.cameraId,rtspUrl:cmdForm.rtspUrl,model:cmdForm.model})
    })
    .then(function(r){return r.json();})
    .then(function(d){
      setCmdLog(function(prev){return [{ts:new Date().toLocaleTimeString(),agent:agentId,cmd:"start_inference",result:d.success?"OK":"FAIL",msg:d.message||d.error||""}].concat(prev).slice(0,50);});
      setCmdModal(null);
    })
    .catch(function(e){
      setCmdLog(function(prev){return [{ts:new Date().toLocaleTimeString(),agent:agentId,cmd:"start_inference",result:"ERR",msg:e.message}].concat(prev).slice(0,50);});
    });
  }

  function sendSwitchModel(agentId){
    var agent=agents[agentId]||{};
    fetch(API+"/api/agents/"+agentId+"/switch-model",{
      method:"POST",headers:headers,
      body:JSON.stringify({tenantId:agent.tenantId||"T6514",siteId:agent.siteId||"ST-002",cameraId:cmdForm.cameraId||"CAM-9059",model:cmdForm.model})
    })
    .then(function(r){return r.json();})
    .then(function(d){
      setCmdLog(function(prev){return [{ts:new Date().toLocaleTimeString(),agent:agentId,cmd:"switch_model",result:d.success?"OK":"FAIL",msg:d.message||d.error||""}].concat(prev).slice(0,50);});
      setCmdModal(null);
    })
    .catch(function(e){
      setCmdLog(function(prev){return [{ts:new Date().toLocaleTimeString(),agent:agentId,cmd:"switch_model",result:"ERR",msg:e.message}].concat(prev).slice(0,50);});
    });
  }

  var agentList=Object.keys(agents).map(function(k){return Object.assign({},agents[k],{id:k});});
  var onlineCount=agentList.filter(function(a){return a.status==="online";}).length;
  var offlineCount=agentList.filter(function(a){return a.status==="offline";}).length;

  if(loading)return <div style={{padding:60,textAlign:"center",color:T.muted,fontFamily:T.font}}>Loading MQTT agents...</div>;

  return <div style={{fontFamily:T.font,color:T.text}}>
    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:24}}>
      <div>
        <div style={{fontSize:22,fontWeight:800}}>MQTT Agent Control</div>
        <div style={{fontSize:13,color:T.muted,marginTop:4}}>Real-time edge agent command & monitoring via MQTT</div>
      </div>
      <div style={{display:"flex",gap:8}}>
        <Btn onClick={fetchAgents} bg={T.blue} sm>Refresh</Btn>
      </div>
    </div>

    {/* KPI Cards */}
    <div style={{display:"grid",gridTemplateColumns:"repeat(5,1fr)",gap:14,marginBottom:24}}>
      <SC l="Total Agents" v={agentList.length} s="Registered via MQTT" c={T.blue}/>
      <SC l="Online" v={onlineCount} s="Heartbeat active" c={T.green}/>
      <SC l="Offline" v={offlineCount} s="No heartbeat" c={offlineCount>0?T.red:T.muted}/>
      <SC l="Commands Sent" v={cmdLog.length} s="This session" c={T.accent}/>
      <SC l="Protocol" v="MQTT" s="QoS 1 \u2022 Mosquitto 2.x" c={T.teal}/>
    </div>

    {/* Agent Cards */}
    {agentList.length===0?
      <Crd><Empty t="No Agents Connected" s="Start an edge agent with --mqtt-host to see it here. Run: python edge_agent.py --demo --mqtt-host localhost"/></Crd>
    :
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16,marginBottom:16}}>
        {agentList.map(function(a){
          var isOnline=a.status==="online";
          var isSending=sending.startsWith(a.id+":");
          var lastSeen=a.lastSeen?new Date(a.lastSeen).toLocaleTimeString():"--";
          var uptime=a.uptime?Math.floor(a.uptime/60)+"m "+Math.floor(a.uptime%60)+"s":"--";

          return <div key={a.id} style={{background:T.card,borderRadius:12,border:"1px solid "+(isOnline?T.green+"44":T.red+"44"),padding:18}}>
            {/* Header */}
            <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
              <div style={{display:"flex",alignItems:"center",gap:10}}>
                <div style={{width:10,height:10,borderRadius:"50%",background:isOnline?T.green:T.red,boxShadow:isOnline?"0 0 8px "+T.green+"88":"none"}}/>
                <div>
                  <div style={{fontSize:14,fontWeight:800}}>{a.id||a.agentId}</div>
                  <div style={{fontSize:10,color:T.muted}}>{a.tenantId}/{a.siteId}</div>
                </div>
              </div>
              <Bd t={a.status||"unknown"} c={sc(a.status||"unknown")}/>
            </div>

            {/* Metrics */}
            <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:8,marginBottom:14}}>
              {[
                {l:"FPS",v:a.fps||"--"},
                {l:"Cameras",v:a.camerasActive||0},
                {l:"Uptime",v:uptime},
                {l:"CPU Temp",v:a.cpuTemp?a.cpuTemp+"\u00B0C":"--"},
                {l:"GPU Temp",v:a.gpuTemp?a.gpuTemp+"\u00B0C":"--"},
                {l:"Last Seen",v:lastSeen},
              ].map(function(m,i){return <div key={i} style={{background:T.faint,borderRadius:6,padding:"6px 8px"}}>
                <div style={{fontSize:9,color:T.muted,fontWeight:600,textTransform:"uppercase"}}>{m.l}</div>
                <div style={{fontSize:12,fontWeight:700,fontFamily:T.mono,marginTop:2}}>{m.v}</div>
              </div>;})}
            </div>

            {/* Telemetry row */}
            {a.memoryUsage&&<div style={{display:"flex",gap:12,marginBottom:14,fontSize:10,color:T.muted}}>
              <span>RAM: <b style={{color:T.text}}>{a.memoryUsage}%</b></span>
              <span>Disk: <b style={{color:T.text}}>{a.diskUsage}%</b></span>
              <span>Model: <b style={{color:T.text}}>{a.modelLoaded||"--"}</b></span>
              {a.inferenceLatencyMs&&<span>Latency: <b style={{color:T.text}}>{a.inferenceLatencyMs}ms</b></span>}
            </div>}

            {/* Command Buttons */}
            <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
              <Btn onClick={function(){sendCmd(a.id,"ping");}} bg={T.blue} sm disabled={isSending}>Ping</Btn>
              <Btn onClick={function(){setCmdModal({agent:a.id,type:"start"});setCmdForm({cameraId:"",rtspUrl:"",model:"person_detection"});}} bg={T.green} sm disabled={isSending}>Start Inference</Btn>
              <Btn onClick={function(){sendCmd(a.id,"stop_inference",{camera_id:"CAM-9059"});}} bg={T.orange} sm disabled={isSending}>Stop</Btn>
              <Btn onClick={function(){setCmdModal({agent:a.id,type:"switch"});setCmdForm({cameraId:"CAM-9059",rtspUrl:"",model:"person_detection"});}} bg={T.purple} sm disabled={isSending}>Switch Model</Btn>
              <Btn onClick={function(){if(window.confirm("Restart agent "+a.id+"?"))sendCmd(a.id,"restart_agent");}} bg={T.red} sm disabled={isSending}>Restart</Btn>
            </div>
          </div>;
        })}
      </div>
    }

    {/* Command Log */}
    <Crd title={"Command Log ("+cmdLog.length+")"} accent>
      {cmdLog.length===0?<Empty t="No Commands Sent" s="Use the buttons above to send commands to connected agents"/>:
      <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}><thead><tr><TH>Time</TH><TH>Agent</TH><TH>Command</TH><TH>Result</TH><TH>Message</TH></tr></thead><tbody>
      {cmdLog.slice(0,20).map(function(c,i){return <tr key={i} style={{borderBottom:"1px solid "+T.border+"44"}}>
        <TD mono>{c.ts}</TD>
        <TD bold>{c.agent}</TD>
        <TD><Bd t={c.cmd} c={T.blue}/></TD>
        <TD><Bd t={c.result} c={c.result==="OK"?T.green:T.red}/></TD>
        <TD>{(c.msg||"").substring(0,80)}</TD>
      </tr>;})}</tbody></table>}
    </Crd>

    {/* Topic Reference */}
    <Crd title="MQTT Topic Map">
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
        <div>
          <div style={{fontSize:11,fontWeight:700,color:T.accent,marginBottom:8}}>Backend \u2192 Agent (Commands)</div>
          {[
            "auravex/{tenant}/{site}/{agent}/command"
          ].map(function(t,i){return <div key={i} style={{fontFamily:T.mono,fontSize:10,padding:"4px 0",color:T.text}}>{t}</div>;})}
          <div style={{fontSize:10,color:T.muted,marginTop:6}}>Commands: ping, start_inference, stop_inference, switch_model, restart_agent, update_config</div>
        </div>
        <div>
          <div style={{fontSize:11,fontWeight:700,color:T.green,marginBottom:8}}>Agent \u2192 Backend (Status)</div>
          {[
            "auravex/{tenant}/{site}/{agent}/status",
            "auravex/{tenant}/{site}/{agent}/telemetry",
            "auravex/{tenant}/{site}/{camera}/incident",
          ].map(function(t,i){return <div key={i} style={{fontFamily:T.mono,fontSize:10,padding:"4px 0",color:T.text}}>{t}</div>;})}
          <div style={{fontSize:10,color:T.muted,marginTop:6}}>Status: every 5s \u2022 Telemetry: every 30s \u2022 Incidents: on detection</div>
        </div>
      </div>
    </Crd>

    <div style={{marginTop:8,padding:12,background:T.faint,borderRadius:8,fontSize:11,color:T.muted,fontFamily:T.mono,textAlign:"center"}}>
      MQTT Broker: Mosquitto 2.x \u2022 Port 1883 (TCP) \u2022 Port 9001 (WebSocket) \u2022 QoS 1 \u2022 Persistent Sessions
    </div>

    {/* Start Inference Modal */}
    {cmdModal&&cmdModal.type==="start"&&<div style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,0.5)",zIndex:9999,display:"flex",alignItems:"center",justifyContent:"center"}} onClick={function(){setCmdModal(null);}}>
      <div style={{background:T.card,borderRadius:12,padding:24,width:420,maxWidth:"90%"}} onClick={function(e){e.stopPropagation();}}>
        <div style={{fontSize:16,fontWeight:800,marginBottom:16}}>Start Inference \u2014 {cmdModal.agent}</div>
        <div style={{marginBottom:12}}>
          <label style={{fontSize:11,fontWeight:600,color:T.muted,display:"block",marginBottom:4}}>Camera ID</label>
          <input value={cmdForm.cameraId} onChange={function(e){setCmdForm(Object.assign({},cmdForm,{cameraId:e.target.value}));}} placeholder="CAM-9059" style={{width:"100%",padding:"8px 12px",borderRadius:8,border:"1px solid "+T.border,fontFamily:T.font,fontSize:12,boxSizing:"border-box"}}/>
        </div>
        <div style={{marginBottom:12}}>
          <label style={{fontSize:11,fontWeight:600,color:T.muted,display:"block",marginBottom:4}}>RTSP URL</label>
          <input value={cmdForm.rtspUrl} onChange={function(e){setCmdForm(Object.assign({},cmdForm,{rtspUrl:e.target.value}));}} placeholder="rtsp://admin:pass@192.168.0.10:554/stream1" style={{width:"100%",padding:"8px 12px",borderRadius:8,border:"1px solid "+T.border,fontFamily:T.font,fontSize:12,boxSizing:"border-box"}}/>
        </div>
        <div style={{marginBottom:16}}>
          <label style={{fontSize:11,fontWeight:600,color:T.muted,display:"block",marginBottom:4}}>AI Model</label>
          <select value={cmdForm.model} onChange={function(e){setCmdForm(Object.assign({},cmdForm,{model:e.target.value}));}} style={{width:"100%",padding:"8px 12px",borderRadius:8,border:"1px solid "+T.border,fontFamily:T.font,fontSize:12,boxSizing:"border-box"}}>
            <option value="person_detection">Person Detection</option>
            <option value="vehicle_detection">Vehicle Detection</option>
            <option value="face_recognition">Face Recognition</option>
          </select>
        </div>
        <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
          <Btn onClick={function(){setCmdModal(null);}} bg={T.muted} sm>Cancel</Btn>
          <Btn onClick={function(){sendStartInference(cmdModal.agent);}} bg={T.green} sm disabled={!cmdForm.cameraId||!cmdForm.rtspUrl}>Start</Btn>
        </div>
      </div>
    </div>}

    {/* Switch Model Modal */}
    {cmdModal&&cmdModal.type==="switch"&&<div style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,0.5)",zIndex:9999,display:"flex",alignItems:"center",justifyContent:"center"}} onClick={function(){setCmdModal(null);}}>
      <div style={{background:T.card,borderRadius:12,padding:24,width:380,maxWidth:"90%"}} onClick={function(e){e.stopPropagation();}}>
        <div style={{fontSize:16,fontWeight:800,marginBottom:16}}>Switch Model \u2014 {cmdModal.agent}</div>
        <div style={{marginBottom:12}}>
          <label style={{fontSize:11,fontWeight:600,color:T.muted,display:"block",marginBottom:4}}>Camera ID</label>
          <input value={cmdForm.cameraId} onChange={function(e){setCmdForm(Object.assign({},cmdForm,{cameraId:e.target.value}));}} placeholder="CAM-9059" style={{width:"100%",padding:"8px 12px",borderRadius:8,border:"1px solid "+T.border,fontFamily:T.font,fontSize:12,boxSizing:"border-box"}}/>
        </div>
        <div style={{marginBottom:16}}>
          <label style={{fontSize:11,fontWeight:600,color:T.muted,display:"block",marginBottom:4}}>New Model</label>
          <select value={cmdForm.model} onChange={function(e){setCmdForm(Object.assign({},cmdForm,{model:e.target.value}));}} style={{width:"100%",padding:"8px 12px",borderRadius:8,border:"1px solid "+T.border,fontFamily:T.font,fontSize:12,boxSizing:"border-box"}}>
            <option value="person_detection">Person Detection</option>
            <option value="vehicle_detection">Vehicle Detection</option>
            <option value="face_recognition">Face Recognition</option>
          </select>
        </div>
        <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
          <Btn onClick={function(){setCmdModal(null);}} bg={T.muted} sm>Cancel</Btn>
          <Btn onClick={function(){sendSwitchModel(cmdModal.agent);}} bg={T.purple} sm disabled={!cmdForm.cameraId}>Switch</Btn>
        </div>
      </div>
    </div>}
  </div>;
}

export default MqttAgentControlPage;
